import {Component} from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import { strict } from 'assert';
import { RegisterService } from '../app/_services/register.service';
import { Register } from '../app/_services/register.service';
import { ResellerRegister } from '../app/_services/register.service';
import { Observable, Subject, of } from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Country } from '../app/_services/register.service';
import {Province } from '../app/_services/register.service';
import {MatCheckbox} from '@angular/material/checkbox';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

function emailDomainValidator(control: FormControl) { (1)
  let email = control.value; (2)

  if (email && email.indexOf("@") != -1) { (3)
    let [_, domain] = email.split("@"); (4)
    domain=domain.toLowerCase();
    if (domain == "gmail.com" || domain == "gmail.ca" || domain == "aol.com" || domain == "aol.ca" || domain == "outlook.com" || domain == "outlook.ca" || domain == "mail.com" || domain == "mail.ca" || domain == "yahoo.com" || domain == "yahoo.ca" || domain == "hotmail.com" || domain == "hotmail.ca" || domain == "icloud.com" || domain == "icloud.ca") { (5)
      return {
        emailDomain: {
          parsedDomain: domain
        }
      }
    }    
  }
  return null; (6)
}



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  CAStar: string;
  USAStar: string;
  datemask = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  register: Register;
  resellerRegister: ResellerRegister;
  public emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
    emailDomainValidator  
  ]);

  public firstNameFormControl = new FormControl('', [
    Validators.required
  ]);

  public lastNameFormControl = new FormControl('', [
    Validators.required
  ]);

  public jobTitleFormControl = new FormControl('', [
    Validators.required
  ]);

  public userNameFormControl = new FormControl('', [
    Validators.required
  ]);

  public accountTypeFormControl = new FormControl('', [
    Validators.required
  ]);

  public phoneNumberFormControl= new FormControl('', [
    Validators.required,
    Validators.pattern(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}$"))
  ]);

  public phoneExtNumberFormControl= new FormControl('');


  public companyNameFormControl= new FormControl('', [
    Validators.required
  ]);

  public address1FormControl= new FormControl('', [
    Validators.required
  ]);

  public address2FormControl= new FormControl('');

  public cityFormControl= new FormControl('', [
    Validators.required
  ]);

  public postalCodeFormControl= new FormControl('', [
    Validators.required
  ]);

  public countryFormControl = new FormControl('', [
    Validators.required
  ]);

  public provinceFormControl = new FormControl('', [
    Validators.required
  ]);

  public iAgreeFormControl = new FormControl('', [
    Validators.requiredTrue
  ]);

  public synnexCAFormControl= new FormControl('');
  public techdataCAFormControl= new FormControl('');
  public ingrammicroCAFormControl= new FormControl('');
  public dandhCAFormControl= new FormControl('');
  public asiCAFormControl= new FormControl('');
  

  public synnexUSAFormControl= new FormControl('');
  public techdataUSAFormControl= new FormControl('');
  public ingrammicroUSAFormControl= new FormControl('');
  public dandhUSAFormControl= new FormControl('');
  public asiUSAFormControl= new FormControl('');
  


  matcher = new MyErrorStateMatcher();

  test:any;

  step1:boolean=true;
  step2:boolean=false;
  step3:boolean=false;
  step4:boolean=false;
  step5:boolean=false;
  stepAnyEmailExist:boolean=false;
  isEmailAlreadyExists:boolean;
  isUserIdAlreadyExists:boolean;
  accountDoesntExist:boolean=false;
  stepEndUserConfirm:boolean=false;
  stepDistributorConfirm:boolean=false;
  stepComingSoon:boolean=false;
  stepResellerResgister:boolean=false;

  isDistEmailAlreadyExists:boolean=false;
  isManuEmailAlreadyExists:boolean=false;
  ipAddress:any;
  isResellerEmailAlreadyExists:boolean=false;

  public isUserIdAlreadyExistsMsg:boolean=false;

  countries:Country[];
  provinces:Province[];
  constructor(private registerService:RegisterService,private http: HttpClient){
    //this.accountTypeFormControl.setValue(0);
    this.http.get<{ip:string}>('https://jsonip.com')
    .subscribe( data => {
      console.log('th data', data);
      this.ipAddress = data
    })

    this.registerService.getAllCounties().subscribe(c=>this.countries=c);
  }

  loadProvinces(companyid:number): void {    
    //alert(companyid);    
    this.provinces = [];    
    this.registerService.getAllByCountryId(companyid).subscribe(c=>this.provinces =c);        
 
  }
  
  userNameValidator(control: FormControl) {
if (this)
{
   if (this.isUserIdAlreadyExists != undefined)
    {
       if (this.isUserIdAlreadyExists==true) { 
        return {
          userNameExists: {
            exists: this.isUserIdAlreadyExists
          }
        }
      }     
    }
}
   
      
    return null; 
  }

  step1Next() {
    //alert(this.emailFormControl.value);
    ///this.step1=false;
    ///this.step2=true;

   
    
    this.registerService.isEmailAlreadyExists(this.emailFormControl.value).subscribe(a=>{
        this.isEmailAlreadyExists=a;
         if (this.isEmailAlreadyExists==true)
          {
            this.step1=false;
            //alert("Email already exists.");
            this.stepAnyEmailExist=true;
            this.registerService.sendEmailToAnyAlreadyExists(this.emailFormControl.value).subscribe(b=>{});


          }
          else
          {
            //this.accountDoesntExist=true;
            //this.step1=false;
            //this.step2=true;

            this.registerService.isResellerEmailAlreadyExists(this.emailFormControl.value).subscribe(r=>{
              this.isResellerEmailAlreadyExists=r;

              this.registerService.isDistEmailAlreadyExists(this.emailFormControl.value).subscribe(a=>{
                this.isDistEmailAlreadyExists=a;
  
                      this.registerService.isManuEmailAlreadyExists(this.emailFormControl.value).subscribe(a=>{
                      this.isManuEmailAlreadyExists=a;
                      
                      if (this.isResellerEmailAlreadyExists==true)
                      {
                          this.step1=false;
                          this.step5=true;
                          this.registerService.sendEmailToAlreadyExists(this.emailFormControl.value).subscribe(b=>{});
                      }                      
                      else if (this.isManuEmailAlreadyExists==true || this.isDistEmailAlreadyExists==true)
                      {
                        if (this.isDistEmailAlreadyExists==true)
                        this.accountTypeFormControl.setValue(1);
  
                        if (this.isManuEmailAlreadyExists==true)
                        this.accountTypeFormControl.setValue(2);
  
                        this.accountDoesntExist=false;
                        this.step1=false;
                        this.step3=true;
                      }              
                      else
                      {
                        this.accountDoesntExist=true;  
                        this.step1=false;
                        this.step2=true;
                      }
  
                    });
              });

            });


           
        
           
          }
    });
  
    //this.register=new Register();
    //this.register.email="ajassal@itimpex.com";
    //this.register.firstname="A";
    //this.register.lastname="J";
    //this.register.title="CEO";
    //this.register.userid="aj007123";
    //alert('1');
    //this.registerService.add(this.register).subscribe(a=>{
    // this.test=a; 
    //});
    //alert('3');
  }
  step2Next() {
    
    this.step1=false;
    this.step2=false;
    this.step3=true;
  }

  stepRegisterEndUser() { 
    this.register=new Register();
    this.register.email=this.emailFormControl.value;
    this.register.firstname="";
    this.register.lastname="";
    this.register.title="";
    this.register.userid="";
    this.register.phone="";
    this.register.accounttype=3;

    this.registerService.add(this.register).subscribe(a=>{
      this.test=a; 
       this.step1=false;
       this.step2=false;
       this.step3=false;
       this.step4=false;
       this.stepEndUserConfirm=true;       
     });
  }

  stepRegisterReseller() { 
    this.step1=false;
    this.step2=false;
    this.step3=true;
    this.step4=false;
    this.stepEndUserConfirm=false;   
    this.stepComingSoon=false;   
    this.stepResellerResgister=true;
  }

  stepRegisterResellerToDB() { 

    this.registerService.isUserIdAlreadyExists(this.userNameFormControl.value).subscribe(a=>{
      this.isUserIdAlreadyExists=a;
       if (this.isUserIdAlreadyExists==true)
        {
         alert("User ID already taken.");
         this.isUserIdAlreadyExistsMsg=true;
        }
        else
        {         
          if (this.countryFormControl.value==37)
            {
              if (this.synnexCAFormControl.value=="") 
              {
                alert("Please enter Canada's Distributor Synnex Account #.");
                this.CAStar = "*";
                this.USAStar = "";
                return false;
              }              
            }
            if (this.countryFormControl.value==222)
            {
              if (this.synnexUSAFormControl.value=="") 
              {
                alert("Please enter USA's Distributor Synnex Account #.");
                this.USAStar = "*";
                this.CAStar = "";
                return false;
              }     
            }

            this.resellerRegister=new ResellerRegister();
            this.resellerRegister.email=this.emailFormControl.value;
            this.resellerRegister.firstname=this.firstNameFormControl.value;
            this.resellerRegister.lastname=this.lastNameFormControl.value;
            this.resellerRegister.title=this.jobTitleFormControl.value;
            this.resellerRegister.userid=this.userNameFormControl.value;
            this.resellerRegister.phone=this.phoneNumberFormControl.value;
            this.resellerRegister.phoneExt=this.phoneExtNumberFormControl.value;
            this.resellerRegister.accounttype=0;
            this.resellerRegister.companyName=this.companyNameFormControl.value;
            this.resellerRegister.address1=this.address1FormControl.value;
            this.resellerRegister.address2=this.address2FormControl.value;
            this.resellerRegister.city=this.cityFormControl.value;
            this.resellerRegister.country=this.countryFormControl.value;
            this.resellerRegister.province=this.provinceFormControl.value;
            this.resellerRegister.postalCode=this.postalCodeFormControl.value;
            this.resellerRegister.group="9";
            this.resellerRegister.currentlyInGroup="";
            this.resellerRegister.currentlyInGroupName="";   
            this.resellerRegister.ipAddress=this.ipAddress.ip;

            // add distributors account numbers
           
            this.resellerRegister.synnex_CA=this.synnexCAFormControl.value;
            this.resellerRegister.techdata_CA=this.techdataCAFormControl.value;
            this.resellerRegister.ingramMicro_CA=this.ingrammicroCAFormControl.value;
            this.resellerRegister.dandH_CA=this.dandhCAFormControl.value;
            this.resellerRegister.asi_CA=this.asiCAFormControl.value;
            this.resellerRegister.synnex_USA=this.synnexUSAFormControl.value;
            this.resellerRegister.techdata_USA=this.techdataUSAFormControl.value;
            this.resellerRegister.ingramMicro_USA=this.ingrammicroUSAFormControl.value;
            this.resellerRegister.dandH_USA=this.dandhUSAFormControl.value;
            this.resellerRegister.asi_USA=this.asiUSAFormControl.value;

            this.registerService.addReseller(this.resellerRegister).subscribe(a=>{
              this.test=a; 
              this.step1=false;
              this.step2=false;
              this.step3=false;
              this.step4=true;
              this.stepEndUserConfirm=false;       
            });        
        }
  }); 



    
  }

  step3Next() {   
    //this.step1=false;
    //this.step2=false;
    //this.step3=false;
    //this.step4=true;

    this.registerService.isUserIdAlreadyExists(this.userNameFormControl.value).subscribe(a=>{
      this.isUserIdAlreadyExists=a;
       if (this.isUserIdAlreadyExists==true)
        {
         alert("User ID already taken.");
         this.isUserIdAlreadyExistsMsg=true;
        }
        else
        {
          if (this.accountDoesntExist==true)
          {          
            //create account
            this.register=new Register();
            this.register.email=this.emailFormControl.value;
            this.register.firstname=this.firstNameFormControl.value;
            this.register.lastname=this.lastNameFormControl.value;
            this.register.title=this.jobTitleFormControl.value;
            this.register.userid="";
            this.register.phone=this.phoneNumberFormControl.value;
            this.register.phoneExt=this.phoneExtNumberFormControl.value;
            this.register.accounttype=this.accountTypeFormControl.value;
          }
          else
          {
            // email
            this.register=new Register();
            this.register.email=this.emailFormControl.value;
            this.register.firstname=this.firstNameFormControl.value;
            this.register.lastname=this.lastNameFormControl.value;
            this.register.title=this.jobTitleFormControl.value;
            this.register.userid=this.userNameFormControl.value;
            this.register.phone="";
            this.register.phoneExt="";
            this.register.accounttype=this.accountTypeFormControl.value;  
          }
   
            
            this.registerService.add(this.register).subscribe(a=>{
             this.test=a; 
              this.step1=false;
              this.step2=false;
              this.step3=false;

              if (this.accountDoesntExist==true)
              {  
                this.stepDistributorConfirm=true;
              }
              else
              {
                this.step4=true;
              }
              
            });
        
        }
  }); 
 
  }
}
